import { render, staticRenderFns } from "./IframeDrive.vue?vue&type=template&id=5705535e"
import script from "./IframeDrive.vue?vue&type=script&lang=js"
export * from "./IframeDrive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports